const TOKEN_KEY = 'alder_token';
const API_BASE = import.meta.env.VITE_API_BASE || 'https://api.alderadvisor.com';

interface DecodedToken {
  role: 'admin' | 'advisor' | 'client';
  exp: number;
  [key: string]: unknown;
}

interface RoleDestinations {
  [key: string]: string;
}

export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};

const decodePayload = (token: string): DecodedToken | null => {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64)) as DecodedToken;
  } catch {
    return null;
  }
};

const ROLE_DESTINATIONS: RoleDestinations = {
  admin: 'admin-landing.html',
  advisor: 'advisor-landing.html',
  client: 'client-landing.html',
};

export const redirectByRole = (): void => {
  const token = getToken();
  if (!token) return;
  const payload = decodePayload(token);
  if (!payload || payload.exp * 1000 < Date.now()) {
    clearToken();
    return;
  }
  const dest = ROLE_DESTINATIONS[payload.role];
  if (dest) window.location.replace(dest);
};

export const requireRole = (...roles: Array<'admin' | 'advisor' | 'client'>): void => {
  const token = getToken();
  if (!token) {
    window.location.replace('signin.html');
    return;
  }
  const payload = decodePayload(token);
  if (!payload || payload.exp * 1000 < Date.now()) {
    clearToken();
    window.location.replace('signin.html');
    return;
  }
  if (!roles.includes(payload.role)) {
    window.location.replace('signin.html');
  }
};

export const signOut = async (): Promise<void> => {
  const token = getToken();
  if (token) {
    try {
      await fetch(`${API_BASE}/auth/logout`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch {
      // proceed with local signout regardless of network failure
    }
  }
  clearToken();
  window.location.replace('signin.html');
};
